import { LocalStorageKeys } from '@/constants/localstorage'
import { MarginType } from '@/types/Margin'
import { getUserScopedItem } from '@/utils/userScopedStorage'

export const DEFAULT_TRADE_MARGIN_TYPE = MarginType.CASH

export const getPreferredTradeMarginType = (): MarginType => {
  const preference = getUserScopedItem(LocalStorageKeys.DEFAULT_TRADING_MODE)
  if (preference === MarginType.CASH || preference === MarginType.ISOLATED) return preference

  const lastUsed = getUserScopedItem(LocalStorageKeys.LAST_USED_TRADING_MODE)
  return isMarginType(lastUsed) ? lastUsed : DEFAULT_TRADE_MARGIN_TYPE
}

export const TRADE_MARGIN_OPTIONS = [
  {
    value: MarginType.CASH,
    emoji: '🏦',
    title: 'Cash',
    description: 'Trade using your own balance. No borrowing or leverage.',
    tradeLabel: 'Cash (No Leverage)',
  },
  {
    value: MarginType.ISOLATED,
    emoji: '⚡',
    title: 'Isolated (Leverage)',
    description:
      'Borrow funds to open long or short positions with leverage. Higher risk. Positions can be liquidated.',
    tradeLabel: 'Isolated (Leverage)',
  },
] as const

export const isMarginType = (value: unknown): value is MarginType =>
  value === MarginType.CASH || value === MarginType.ISOLATED

export const normalizeTradeMarginType = (value: unknown): MarginType =>
  isMarginType(value) ? value : DEFAULT_TRADE_MARGIN_TYPE
